exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-tile__tile{background-color:#cecdcd;margin:0;border-radius:3px;border-right:1px solid #dedede!important;border-bottom:1px solid #dedede!important;-webkit-transition:color .1s,background-color .1s linear,border-color .1s linear;-ms-transition:color .1s,background-color .1s linear,border-color .1s linear;transition:color .1s,background-color .1s linear,border-color .1s linear;padding:1em}.nil-sa-elements-tile__tile.nil-sa-elements-tile__transparent{background-color:transparent;border-right:1px solid transparent!important;border-bottom:1px solid transparent!important;padding:1em 0}.nil-sa-elements-tile__tile.nil-sa-elements-tile__selected>div{background-color:#ff7601}.nil-sa-elements-tile__tile .nil-sa-elements-tile__title{position:relative;display:block;background-color:#cecece;margin-bottom:0;border-radius:3px 3px 0 0}.nil-sa-elements-tile__tile .nil-sa-elements-tile__title h2{padding:1em 1.5em;font-size:1.2em}.nil-sa-elements-tile__tile .nil-sa-elements-tile__body{position:relative;width:100%;padding:1.5em}", ""]);

// exports
exports.locals = {
	"tile": "nil-sa-elements-tile__tile",
	"transparent": "nil-sa-elements-tile__transparent",
	"selected": "nil-sa-elements-tile__selected",
	"title": "nil-sa-elements-tile__title",
	"body": "nil-sa-elements-tile__body"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/Tile/index.less
// module id = 398
// module chunks = 0